export function WebsiteAnalyticsNotice() {
  return (
    <section id="website-analytics">
      <h2>Optional website analytics</h2>
      <p>
        This notice covers the alxnsv.io website, including its product pages.
        If you choose Allow analytics, the website uses Google Analytics to
        measure page visits and clicks on app-store, early-access, and contact
        links. Google may process cookie identifiers, browser and device
        information, and approximate location derived from your IP address.
        These measurements help us understand which pages are useful.
      </p>
      <p>
        Analytics loads only after you opt in. We store your choice in your
        browser. You can decline or change your choice using Analytics
        preferences. We disable advertising features and do not send email
        addresses, email contents, spool inventory, or Firestore documents as
        analytics events. A contact-link click does not tell us whether you
        actually sent an email.
      </p>
      <p>
        Withdrawing consent stops future collection in this browser and removes
        the website’s Analytics cookies; it does not erase information already
        processed by Google. See{' '}
        <a href="https://policies.google.com/privacy">
          Google’s Privacy Policy
        </a>{' '}
        for information about Google’s processing. Hosting and security services
        may still process ordinary request data such as IP address, user agent,
        requested page, and access time to deliver and protect the site.
      </p>
    </section>
  );
}
